import { isNullish } from './type-check'

export const parseNumberOrNull = (value: string | null | undefined): number | null => {
  if(isNullish(value)) return null
  const num = Number(value)
  if(Number.isNaN(num)) return null
  return num
}